
import { defineComponent } from "vue";
import { Container, Section, Heading2 } from "@/components/layout";
import { Timeline } from "@/components/common";
import { useContent } from "@/hooks";

export default defineComponent({
  name: "Experience",
  components: { Container, Section, Heading2, Timeline },
  setup() {
    const { jobs } = useContent();

    return { entities: jobs };
  },
});
